import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { Flex, VStack } from '@chakra-ui/react';
import { Link as GatsbyLink, useStaticQuery } from 'gatsby';
import React from 'react';
import ButtonLink from '../ButtonLink';
import Image from '../Image';
import Text from '../Text';

var Hero = function Hero(props) {
  var backgroundImage = props.backgroundImage,
      _props$couleurTitre = props.couleurTitre,
      couleurTitre = _props$couleurTitre === void 0 ? '#000' : _props$couleurTitre,
      ctas = props.ctas,
      heading = props.heading,
      _props$hideLogoOnMobi = props.hideLogoOnMobile,
      hideLogoOnMobile = _props$hideLogoOnMobi === void 0 ? true : _props$hideLogoOnMobi,
      form = props.form,
      size = props.size,
      tagline = props.tagline,
      rest = _objectWithoutPropertiesLoose(props, ["backgroundImage", "couleurTitre", "ctas", "heading", "hideLogoOnMobile", "form", "size", "tagline"]);

  var HERO_SIZES = {
    long: {
      base: 500,
      md: 700
    },
    medium: {
      base: 500,
      md: 600
    },
    short: {
      base: 300,
      md: 450
    }
  };

  var getHeroSize = function getHeroSize() {
    if (size) return HERO_SIZES[size];
    return form ? HERO_SIZES['medium'] : HERO_SIZES['short'];
  };

  var heroSize = getHeroSize();
  var data = useStaticQuery("2260063460");
  var logo = data.logo;
  return /*#__PURE__*/React.createElement(Flex, Object.assign({
    position: "relative",
    w: "100vw",
    left: "50%",
    right: "50%",
    ml: "-50vw",
    mr: "-50vw",
    justify: "center",
    pt: "0 !important",
    bg: backgroundImage ? 'initial' : 'secondary.500'
  }, rest), backgroundImage ? /*#__PURE__*/React.createElement(Image, {
    style: {
      width: '100%',
      height: '100%'
    },
    image: backgroundImage,
    loading: "eager",
    withOverlay: true,
    overlayOpacity: 0.4
  }) : null, /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    justify: {
      lg: 'flex-end !important'
    },
    align: "center",
    w: "100%",
    px: {
      base: '1rem',
      md: '3rem',
      lg: '6rem',
      xxl: '11rem'
    },
    pt: "100px",
    minH: heroSize
  }, /*#__PURE__*/React.createElement(Flex, {
    align: "center",
    justify: "center",
    position: {
      base: 'relative',
      lg: 'absolute'
    },
    left: {
      lg: '50%'
    },
    top: {
      lg: '50%'
    },
    transform: {
      lg: 'translate(-50%, -50%)'
    },
    zIndex: 2,
    display: hideLogoOnMobile ? {
      base: 'none',
      lg: 'flex'
    } : 'flex'
  }, /*#__PURE__*/React.createElement(GatsbyLink, {
    to: "/"
  }, /*#__PURE__*/React.createElement(Image, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    image: {
      altText: 'Logo de Languages & Travel',
      localFile: logo
    },
    loading: "eager",
    width: [150, 150, 150, 200, 220, 340],
    height: [150, 150, 150, 200, 220, 340]
  }))), /*#__PURE__*/React.createElement(Flex, {
    direction: {
      base: 'column',
      lg: 'row'
    },
    mb: size === 'short' ? {
      base: '3rem',
      lg: '5rem'
    } : {
      base: '3rem',
      lg: '5%'
    },
    alignItems: {
      base: 'center',
      lg: form ? 'flex-start' : 'flex-end'
    },
    width: "100%",
    maxW: form ? {
      base: 250,
      sm: 400,
      lg: '100%'
    } : {
      base: '100%'
    },
    zIndex: 1
  }, /*#__PURE__*/React.createElement(VStack, {
    flex: 1,
    align: "flex-start",
    maxWidth: {
      base: '100%',
      lg: '40%'
    },
    mb: 4
  }, /*#__PURE__*/React.createElement(Text, {
    textVariant: "h1"
  }, heading), tagline, ctas ? /*#__PURE__*/React.createElement(Flex, null, ctas === null || ctas === void 0 ? void 0 : ctas.map(function (cta) {
    return /*#__PURE__*/React.createElement(ButtonLink, {
      key: cta === null || cta === void 0 ? void 0 : cta.label,
      cta: cta
    });
  })) : null), /*#__PURE__*/React.createElement(Flex, {
    justify: "flex-end",
    alignSelf: {
      base: 'stretch'
    },
    flex: 1
  }, form))));
};

export default Hero;